import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { KeyAttributeContent } from "../Components/KeyAttributeContent";

const KeyAttribute = () => {
  const seoData = getSEOData("/user-interface");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <KeyAttributeContent />
    </>
  );
};

export default KeyAttribute;